import React, { FC, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { InputArrayData, InputSelect, InputTextArea } from "../../../../components/input";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { useSelector } from "../../../../store/store";
import { CodeProcessContentStructure, CodeProcessContentForm } from "../code-process/codeProcessContentForm";
import { CreateNotification } from "../../../../components/notifier";
import { Icon } from "../../../../components/icon";
import { ITToolRequestService } from "../../../../services/it-tools-request/itToolRequest.service";
import { MailService } from "../../../../services/mail/mail.service";
import { codeProcessRequestTypes } from "../code-process/codeRequestType";
import { UserSelect } from "../../../../components/input/select/UserSelect";

import { Col, Row } from "react-bootstrap";

import { getEnv } from "../../../../AppConfigs";
import { mailRegexs } from "../../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../../constants/statusConstants";
import { ITToolsService } from "../../../../services/it-tools-request/itTool.service";
import { PeoplePicker, PersonType } from "@microsoft/mgt-react";
import { eApproveTitleCode } from "../../../../constants/bizTitle";

const siteUrl = getEnv("REACT_APP_APPROVER_IT_TOOLS_REQUEST_URL");

export const createToolTechnologyPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { id } = useRouteMatch().params as any;
  const employees = useSelector((state: any) => state.employee.employees);
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const user = useSelector((state: any) => state.user);
  const currentUserName = user?.current?.username;
  const [approverOptions, setApproverOptions] = useState([]);
  const [approver, setApprover] = useState("");
  const [requestType, setRequestType] = useState(codeProcessRequestTypes[0].value);
  const [userDepartment, setUserDepartment] = useState(null as any);
  const [iTTools, setITTools] = useState([]);
  const [iTToolSelected, setITToolSelected] = useState(null as any);
  const { getInputProps, handleSubmit, isSubmitting, setValues } = useForm({
    structure: [
      {
        name: "description",
        label: "Mô tả",
      },
      {
        name: "pickApprover",
        label: "Người duyệt",
      },
      {
        name: "findApprover",
        label: "Người duyệt thay thế",
      },
      {
        name: "tooltechnology",
        label: "Công cụ công nghệ thông tin",
      },
      {
        name: "type",
        label: "Yêu cầu",
      },
      {
        name: "requests",
        label: "Nội dung chi tiết",
        defaultValue: [],
      },
      {
        name: "fullname",
        label: "Người yêu cầu",
      },
      {
        name: "department",
        label: "Đơn vị sử dụng",
      },
    ],
    onSubmit: async (payload) => {
      const { description, requests } = payload;
      const approverTmp = employees.find((f: any) => f.eMail === approver);
      const createdJobTitle = employees.find((f: any) => f.eMail === user?.current?.username?.toLowerCase());
      const software: any = softwares.find((f: any) => f.eSystemCode === "ITT");
      // eslint-disable-next-line eqeqeq
      const itTool: any = iTTools.find((f: any) => f.id == iTToolSelected.value || f.id == iTToolSelected);
      const requestTypeText: any = codeProcessRequestTypes.find((f: any) => f.value === requestType)?.label;
      const assignees = software.eITStaff.split(";");
      const ITToolRequests: any = {
        fields: {
          Title: `${requestTypeText} - ${software.Title} - ${itTool.Title}`,
          eApprovedBy: approverTmp ? `${approverTmp.eMail}|${approverTmp.Title}` : null,
          eSoftwareId: software.id,
          eToolTypeId: itTool.id,
          eApprovedByITLead: `${software.eITTeamLead}|${software.eTeamLeadName}`,
          eApprovedByITHead: `${software.eITHead}|${software.eITHeadName}`,
          eAssignee: `${assignees[0]}`,
          eRequestStatus: requestStatus.submitted,
          eDescription: description,
          eRequestType: requestType,
          eContent: JSON.stringify(requests),
          ePhoneNumber: createdJobTitle.eBizTitle,
        },
      };
      addITToolRequest(ITToolRequests);
    },
  });

  const sendMail = async (approver: any) => {
    const arr = approver.split("|");
    const tomail = arr.length > 0 ? arr[0] : "";
    const name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === "ITTRA");
    const content = template.eContent.replace(mailRegexs.zero, name).replace(mailRegexs.siteUrl, siteUrl);
    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const addITToolRequest = (itToolRequest: any) => {
    // eslint-disable-next-line eqeqeq
    if (id != 0) {
      ITToolRequestService.updateITToolRequest(id, itToolRequest.fields).then(
        (res) => {
          CreateNotification({
            title: "Thành công",
            body: `Chỉnh sửa yêu cầu thành công.`,
            icon: "/icons/success.png",
          });
          history.push(Routes.procedureProcessToolTechnology.path.replace(":id", id));
        },
        (error) => {
          CreateNotification({ title: "Thất bại", body: `Chỉnh sửa yêu cầu thất bại.`, icon: "/icons/error.png" });
          console.log(error);
        },
      );
    } else {
      ITToolRequestService.addITToolRequest(itToolRequest).then(
        (res) => {
          CreateNotification({ title: "Thành công", body: `Tạo yêu cầu thành công.`, icon: "/icons/success.png" });
          if (itToolRequest.fields.eApprovedBy) {
            sendMail(itToolRequest.fields.eApprovedBy);
          }
          history.push(Routes.procedureProcessToolTechnology.path);
        },
        (error) => {
          CreateNotification({ title: "Thất bại", body: `Tạo yêu cầu thất bại.`, icon: "/icons/error.png" });
          console.log(error);
        },
      );
    }
  };

  const getITTools = async () => {
    ITToolsService.getToolsType()
      .then((res: any) => {
        setITTools(res);
      })
      .catch((error) => {
        CreateNotification({
          title: "Thông báo",
          body: "Không thể lấy danh sách loại công cụ",
          icon: "/icons/error.png",
        });
        console.log(error);
      });
  };

  const onItToolChange = (selectedOptions: any) => {
    setITToolSelected(selectedOptions ? selectedOptions : "");
  };

  const onApproverChange = (selectedOptions: any) => {
    setApprover(selectedOptions ? selectedOptions.value : "");
  };

  const onApproverPickerChange = (selectedOptions: any) => {
    setApprover(
      selectedOptions.target.selectedPeople[0]
        ? selectedOptions.target.selectedPeople[0].userPrincipalName.toLowerCase()
        : null,
    );
  };

  const checkUserDepartment = () => {
    const userDepartment = employees.find((o: any) => o.eMail?.toLowerCase() === currentUserName?.toLowerCase());
    setUserDepartment(userDepartment);
  };

  const getApproverOptions = () => {
    const approvers = employees
      .filter(
        (f: any) => eApproveTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartment === userDepartment.eDepartment,
      )
      .map((o: any) => ({ label: o.Title, value: o.eMail, default: o.eDefault || false }));
    setApproverOptions(approvers);
    const defaultApprover = approvers.find((a: any) => a.default);
    setApprover(defaultApprover.value || approvers[0].value);
  };

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (id != 0) {
      ITToolRequestService.getITToolRequest(id)
        .then((res) => {
          const { eDescription, eApprovedBy, eToolTypeId, eRequestType, eContent } = res.fields;
          const approverEmail = eApprovedBy.split("|")[0];
          setValues({ description: eDescription, requests: JSON.parse(eContent) });
          setApprover(approverEmail);
          setITToolSelected(eToolTypeId);
          setRequestType(eRequestType);
        })
        .catch((error) => console.log(error));
    } else {
      setApprover(employees[0]?.eMail);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    getITTools();
  }, [setITTools]);

  useEffect(() => {
    if (employees && employees.length > 0) {
      checkUserDepartment();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employees]);

  useEffect(() => {
    if (userDepartment) {
      getApproverOptions();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDepartment]);

  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.push(Routes.procedureProcessToolTechnology.path)}>
              <Icon.ArrowLeft />
            </div>
            {"Tạo Yêu Cầu Cấp Công Cụ CNTT"}
          </div>
        </div>

        <Box title="Thông tin">
          <form onSubmit={handleSubmit}>
            <InputWraper
              inputProps={getInputProps("tooltechnology")}
              renderInput={(s) => (
                <InputSelect
                  {...s}
                  options={iTTools.map((o: any) => ({ label: o.Title, value: o.id }))}
                  value={iTToolSelected}
                  onChange={onItToolChange}
                  placeholder="* Chọn công cụ"
                />
              )}
            />
            <InputWraper inputProps={getInputProps("description")} component={InputTextArea} />

            <InputWraper
              inputProps={getInputProps("requests")}
              renderInput={(state) => (
                <InputArrayData {...state} form={CodeProcessContentForm} structure={CodeProcessContentStructure} />
              )}
            />
            <Row>
              <Col sm="6" md="6">
                <InputWraper
                  inputProps={getInputProps("pickApprover")}
                  renderInput={(s) => (
                    <UserSelect
                      {...s}
                      placeholder="Chọn người duyệt"
                      options={approverOptions}
                      value={approver}
                      onChange={onApproverChange}
                    />
                  )}
                />
              </Col>
              <Col sm="6" md="6">
                <InputWraper
                  inputProps={getInputProps("findApprover")}
                  renderInput={(s) => (
                    <div className="people_picker-custom">
                      <PeoplePicker
                        className="people-picker"
                        placeholder="Vui lòng chọn người cần gửi tới"
                        type={PersonType.any}
                        selectionChanged={onApproverPickerChange}
                      />
                    </div>
                  )}
                />
              </Col>
            </Row>
            <div className="textRight">
              <Button type="submit" label="Xác nhận" isLoading={isSubmitting} />
              <Button
                type="button"
                label="Huỷ"
                buttonType="danger-outline"
                className="ml10"
                onClick={() => history.push(Routes.procedureProcessToolTechnology.path)}
              />
            </div>
          </form>
        </Box>
      </div>
    </div>
  );
});
